import script from "./PaginatedTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginatedTable.vue?vue&type=script&setup=true&lang=js"

import "./PaginatedTable.vue?vue&type=style&index=0&id=27b252dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b252dd"]])

export default __exports__